import request from '@/utils/request'
import type * as projectType from '@/typings/project'
import type * as memo from '@/typings/memo'
import type { CommonRes, ISystemAccount } from '@/typings'
import {
  IMemoListByProjectReplyNewestMemo,
  IProjectMemoInfo,
  IMemoInfoDetail,
  IProjectPermission
} from '@/typings/project'
import { MeetingMinuteEmptyCheckType } from '@/constants'

// Memo项目列表（常规）
export async function getMemoProjectList(params: projectType.MemoSearchParams) {
  return request('/api/v2/project/memo/search_my_memo_list', {
    method: 'POST',
    data: params
  })
}

// Memo项目列表（卡片）
export async function getMemoCardProjectList(params: projectType.MemoSearchParams) {
  return request('/api/v2/project/memo/search_my_memo_card_list', {
    method: 'POST',
    data: params
  })
}

interface SaveMemoRequest {
  memo: memo.MemoSaveType
  is_draft: boolean
}
// 保存Memo接口
export async function saveMemo(params: SaveMemoRequest) {
  return request('/api/v2/project/memo/save', {
    method: 'POST',
    data: params
  })
}
export async function supplementFoMemo(params: SaveMemoRequest) {
  return request('/api/v2/project/memo/supplement_fo', {
    method: 'POST',
    data: params
  })
}

interface IGetProjectMemoListRequest {
  project_id: number
}
export interface IGetMemoListDataResponse {
  list?: IProjectMemoInfo[]
  newest_memo?: IMemoListByProjectReplyNewestMemo
}
// Memo-获取项目Memo
export async function getMemoListData(params: IGetProjectMemoListRequest) {
  return request<CommonRes<IGetMemoListDataResponse>>('/api/v2/project/memo/list_by_project', {
    method: 'GET',
    data: params
  })
}

interface IGetMemoDetailDataRequest {
  project_id: number
  memo_id: number
  is_need_draft?: number
  is_follow_on?: number
  is_need_newest_log?: number
  from?: number // 1:普通获取 2：编辑时获取 3：超级编辑获取 4:写Memo时获取
}
// Memo-获取Memo详情
export async function getMemoDetailData(params: IGetMemoDetailDataRequest) {
  return request<CommonRes<IMemoInfoDetail>>('/api/v2/project/memo/get', {
    method: 'GET',
    data: params
  })
}

// Memo-进入Memo
export async function enterMemo(params: memo.IEnterMemo) {
  return request('/api/v2/project/memo/enter', {
    method: 'post',
    data: { enterMemo: params }
  })
}

interface IUpdateMemoColorRequest {
  auditor_id?: number
  memo_id?: number
  reason?: string
  vote_solution_id?: number
}
// 项目Memo - 更改Memo颜色
export async function updateMemoColor(params: IUpdateMemoColorRequest) {
  return request('/api/v2/project/memo/update_color', {
    method: 'post',
    data: params
  })
}

interface IPassMemoRequest {
  memo_id?: number
  reason?: string
}
// 项目Memo - Pass Memo
export async function passMemo(params: IPassMemoRequest) {
  return request('/api/v2/project/memo/pass', {
    method: 'post',
    data: params
  })
}

interface GetMemoBasicsRequest {
  project_id: number
}
// 项目Memo - 获取预写Memo信息
export async function getMemoBasics(params: GetMemoBasicsRequest) {
  return request('/api/v2/project/memo/get_memo_basic', {
    method: 'GET',
    data: params
  })
}

interface ICreateMemoProject {
  memo: memo.IEnterMemo
  project: {
    alias: string
    company_name: string
    name: string
  }
}
// 项目Memo - 创建项目写Memo
export async function createMemoProject(params: ICreateMemoProject) {
  return request('/api/v2/project/memo/create_memo_project', {
    method: 'post',
    data: params
  })
}

interface IRollBackMemoPassRequest {
  memo_id?: number
}
// 项目 - 回滚Memo Pass
export async function rollBackMemoPass(params: IRollBackMemoPassRequest) {
  return request('/api/v2/project/memo/rollback_pass', {
    method: 'post',
    data: params
  })
}

interface IDeleteMemoRequest {
  memo_id?: number
}
// 项目 - 删除Memo
export async function deleteMemo(params: IDeleteMemoRequest) {
  return request('/api/v2/project/memo/delete', {
    method: 'post',
    data: params
  })
}

interface IdelMemoDraftRequest {
  id?: number
  is_follow_on?: number
  project_id?: number
}

// 删除memo草稿
export async function delMemoDraft(params: IdelMemoDraftRequest) {
  return request('/api/v2/project/memo/delete_memo_draft', {
    method: 'POST',
    data: params
  })
}

interface IGetOldEmptyMeetingMemoRequest {
  /** 1: 写新Memo（一个月） 2: 写新Log（两个月）；未传按写新Memo */
  check_type: MeetingMinuteEmptyCheckType
}
export async function getOldEmptyMeetingMemo(params: IGetOldEmptyMeetingMemoRequest) {
  return request('/api/v2/file/meeting_minute_has_empty', {
    method: 'GET',
    data: params
  })
}

interface IUpdateMemoIsCheckMeetingRequest {
  is_check_meeting?: number
  memo_id?: number
}
export async function updateMemoIsCheckMeeting(params: IUpdateMemoIsCheckMeetingRequest) {
  return request('/api/v2/project/memo/update_is_check_meeting', {
    method: 'POST',
    data: params
  })
}
interface IUpdateIsAutoMemoPassRequest {
  is_auto_memo_pass?: number
  memo_id?: number
}
export async function updateIsAutoMemoPass(params: IUpdateIsAutoMemoPassRequest) {
  return request('/api/v2/project/memo/update_is_auto_memo_pass', {
    method: 'POST',
    data: params
  })
}
interface IUpdateIsCheckEditParams {
  is_check_edit?: number
  memo_id?: number
}
export async function updateIsCheckEdit(params: IUpdateIsCheckEditParams) {
  return request('/api/v2/project/memo/update_is_check_edit', {
    method: 'POST',
    data: params
  })
}

interface IUpdateOldMemoStatusParams {
  memo_id?: number
  memo_process_step?: number
  memo_process_step_level?: number
}
/** 修改旧 memo 状态（不能修改最新 memo） */
export async function apiUpdateOldMemoStatus(params: IUpdateOldMemoStatusParams) {
  return request('/api/v2/project/memo/update_old_status', {
    method: 'post',
    data: params
  })
}
interface IUpdateProjectAuditParams {
  id: number
  audit_result: number
  audit_reason: string
  handle_result: number
  watch_time: number
  relation_id: number
  audit_type: number
}
// 待审批项目-审批(新接口)
export async function updateProjectAuditV2(params: IUpdateProjectAuditParams) {
  return request('/api/v2/project/memo/update_audit', {
    method: 'post',
    data: params
  })
}

interface IDropRequest {
  memoId: number
  dropLevel: number
  projectId: number
  remark: string
  from: number
}
// Memo详情 - Drop
export async function drop(params: IDropRequest) {
  return request('/api/v2/project/pipeline/drop', {
    method: 'post',
    data: params
  })
}

interface ISetLogMemoVisibleRequest {
  permission: {
    project_id?: number
    related_id?: number
    type?: number
    uids?: number[]
    visible_type?: number
  }
}
// 项目 - 设置项目（Log，Memo）可见性
export async function setLogMemoVisible(params: ISetLogMemoVisibleRequest) {
  return request('/api/v2/project/set_permission', {
    method: 'post',
    data: params
  })
}
interface IGetLogMemoVisibleRequest {
  project_id?: number
  related_id?: number
  type?: number
}
// 项目 - 获取项目（Log，Memo）可见性
export async function getLogMemoVisible(params: IGetLogMemoVisibleRequest) {
  return request<CommonRes<{ permission: IProjectPermission }>>('/api/v2/project/get_permission', {
    method: 'get',
    data: params
  })
}
interface IEnterPortfolioFundListRequest {
  memo_id: number
}
// 获取当前memo的fund和上一个portfolio（如有）的fund
export async function enterPortfolioFundList(params: IEnterPortfolioFundListRequest) {
  return request('/api/v2/project/portfolio/enter_get_info', {
    method: 'GET',
    data: params
  })
}

interface IGetMemoVoteListRequest {
  project_id: number
}
// 获取当前项目的所有memo投票列表
export async function getMemoVoteList(params: IGetMemoVoteListRequest) {
  return request('/api/v2/project/memo/list_for_vote', {
    method: 'GET',
    data: params
  })
}

interface IUpdateProposedInvestmentPlanRequest {
  memo: memo.IMemoDetail
}
// 编辑拟投资方案
export async function updateProposedInvestmentPlan(params: IUpdateProposedInvestmentPlanRequest) {
  return request('/api/v2/project/memo/update_proposed_investment_plan', {
    method: 'POST',
    data: params
  })
}

interface IGetProposedInvestmentRecordListRequest {
  memoId: number
}
// 拟投资方案修改记录
export async function getProposedInvestmentRecordList(
  params: IGetProposedInvestmentRecordListRequest
) {
  return request('/api/v2/project/memo/proposed_investment_plan_update_record_list', {
    method: 'GET',
    data: params
  })
}
/** 开启Memo跟进工作 */
export async function apiOpenMemoFollowUp(params: { memo_id: number }) {
  return request('/api/v2/project/memo/follow_up_open', {
    method: 'POST',
    data: params
  })
}
export interface IUpdateMemoFollowUpParams {
  follow_up_attachment_file_ids?: string[]
  follow_up_content?: string
  memo_id?: number
}

/** 补充Memo跟进工作 */
export async function apiUpdateMemoFollowUp(params: IUpdateMemoFollowUpParams) {
  return request('/api/v2/project/memo/follow_up_update', {
    method: 'POST',
    data: params
  })
}

export interface IUpdateVoteFollowUpParams {
  follow_up_attachment_file_ids?: string[]
  follow_up_content?: string
  vote_id?: number
}

/** 补充Vote跟进工作 */
export async function apiUpdateVoteFollowUp(params: IUpdateVoteFollowUpParams) {
  return request('/api/v2/project/vote/follow_up_update', {
    method: 'POST',
    data: params
  })
}
interface IGetMemoLegalFinanceRequest {
  memo_id: number
}
// Memo-获取项目Memo
export async function getMemoLegalFinance(params: IGetMemoLegalFinanceRequest) {
  return request<CommonRes<{ legal_list: ISystemAccount[]; finance_list: ISystemAccount[] }>>(
    '/api/v2/project/memo/legal_finance_get',
    {
      method: 'GET',
      data: params
    }
  )
}
/** 选择法务财务 */
export interface IUpdateLegalFinanceParams {
  finance_uids?: number[]
  legal_uids?: number[]
  memo_id?: number
}

export async function apiUpdateLegalFinance(params: IUpdateLegalFinanceParams) {
  return request('/api/v2/project/memo/legal_finance_update', {
    method: 'POST',
    data: params
  })
}
export interface IUpdateMemoParams {
  memo_id?: number
  pm_id?: number
}

export async function apiUpdateMemoPm(params: IUpdateMemoParams) {
  return request('/api/v2/project/memo/update_pm', {
    method: 'POST',
    data: params
  })
}
export interface IUpdatePipelineParams {
  memo_id?: number
  pm_id?: number
}

export async function apiUpdatePipelinePm(params: IUpdatePipelineParams) {
  return request('/api/v2/project/pipeline/update_pm', {
    method: 'POST',
    data: params
  })
}
export interface IUpdateIsSpecialPublicParams {
  special_public_time?: number
  memo_id?: number
}

export async function updateIsSpecialPublic(params: IUpdateIsSpecialPublicParams) {
  return request('/api/v2/project/memo/update_is_special_public', {
    method: 'POST',
    data: params
  })
}
export interface IBlueMemoSelectColorParams {
  memo_id?: number
  vote_solution_id?: number
}

export async function apiBlueMemoSelectColor(params: IBlueMemoSelectColorParams) {
  return request<CommonRes<void>>('/api/v2/project/memo/blue_memo_select_color', {
    method: 'POST',
    data: params
  })
}
export interface ICancelBlueMemoColorParams {
  memo_id?: number
}

export async function apiBlueMemoCancelColor(params: ICancelBlueMemoColorParams) {
  return request<CommonRes<void>>('/api/v2/project/memo/blue_memo_select_color_cancel', {
    method: 'POST',
    data: params
  })
}
